export default {
  today: {
    de: 'Heute',
  },
  yesterday: {
    de: 'Gestern',
  },
  'this week': {
    de: 'Diese Woche',
  },
  'this month': {
    de: 'Diesen Monat',
  },
  // Schemas
  'https://codemeta.de/schemas/callback': {
    de: 'Rückruf',
  },
  'https://codemeta.de/schemas/visitor': {
    de: 'Besucher',
  },
  "PRF extension was requested but is not supported by the authenticator": {
    de: "Die PRF-Erweiterung wird vom Authentifikator nicht unterstützt",
  },

  // Password Errors
  'This password is not safe. Please choose another.': {
    de: 'Dieses Passwort wurde in Datenlecks gefunden und ist nicht sicher. Bitte wählen Sie ein anderes Passwort.',
  },
  'This password was recently used. Please choose a different password.': {
    de: 'Dieses Passwort wurde kürzlich verwendet. Bitte wählen Sie ein anderes Passwort.',
  },
  'Passwords do not match': {
    de: 'Die eingegebenen Passwörter stimmen nicht überein.',
  },
  'Email already exists': {
    de: 'Diese E-Mail-Adresse ist bereits registriert.',
  },
};
